import { ldap } from './settings'

class UserLdap {
  constructor() {
    this.ldapClient = ldap
  }

  getUserLdap(args) {
    return new Promise(async (resolve, reject) => {
      return await this.ldapClient.post('/user/registration', args)
      .then(({ data }) => {
        resolve(data)
      })
      .catch((err) =>  {
        console.log(err.message)
        reject(false)
      })
    })
  }

  createUserLdap(data) {
    return new Promise(async (resolve, reject) => {
      return await this.ldapClient.post('/user/create', data)
      .then(({ data }) => {
        resolve(data)
      })
      .catch((err) =>  {
        console.log(err.message)
        reject(false)
      })
    })
  }
  
  updateUserLdap(dn, data) {
    return new Promise(async (resolve, reject) => {
      return await this.ldapClient.put('/user', { dn, data })
      .then(({ data }) => {
        resolve(data)
      })
      .catch((err) =>  {
        console.log(err.message)
        reject(false)
      })
    })
  }

  directoryUpdateLdap(data) {
    return new Promise(async (resolve, reject) => {
      return await this.ldapClient.post('/user/directory', data)
      .then(({ data }) => {
        resolve(data)
      })
      .catch((err) =>  {
        console.log(err.message)
        reject(false)
      })
    })
  }
}

export const userLdap = new UserLdap()